import type { CalendarType, DayOfWeek, VisitTypeDto } from '@lmt/shared-types';
import { CalendarReport } from './CalendarReport';
import type { ReportVisitInfo } from './components/common/types';
import React from 'react';
import { initReactPdf, RPDF } from './components/common/react-pdf';

export async function createReport(options: {
  currentPeriod: { start: Date; end: Date };
  data: ReportVisitInfo[];
  calendarType: CalendarType;
  visitTypes: VisitTypeDto[];
  firstDayOfWeekIndex: DayOfWeek;
  image?: string;
}) {
  const {
    currentPeriod,
    data,
    calendarType,
    visitTypes,
    firstDayOfWeekIndex,
    image,
  } = options;
  await initReactPdf();
  const blob = await RPDF.pdf(
    <CalendarReport
      startDate={currentPeriod.start}
      endDate={currentPeriod.end}
      visits={data}
      calendarType={calendarType}
      visitTypes={visitTypes}
      firstDayOfWeekIndex={firstDayOfWeekIndex}
      image={image}
    />,
  ).toBlob();
  return blob;
}
